import axios from "axios";
export const state = {
    clear_status: false,
    discount_status: false,
    invoice_generate_status: false,
    payment_modes: [],
    patient_payments: [],
    payment_reciepts: [],
    patient_invoices: [],
    deptors: [],
    bad_detors: [],
    account_balance: [],
    patient_invoice_details: {},
    personalInvoiceStatus: false,
    payment_reciept_status: false,
    paymentreciet: {},
    print_reciept: false,
    pay_mode_status: false,
    currencies: []
};
export const getters = {
    Print_reciept: state => state.print_reciept,
    Currency: state => state.currencies,
    ClearStatus: state => state.clear_status,
    PersonalInvoiceStatus: state => state.personalInvoiceStatus,
    PayModeStatus: state => state.pay_mode_status,
    DiscountStatus: state => state.discount_status,
    invoiceGenerateStatus: state => state.invoice_generate_status,
    PaymentRecieptStatus: state => state.payment_reciept_status,
    PaymentModes: state => state.payment_modes.data,
    PatientPayments: state => state.patient_payments.data,
    PaymentsReciept: state => state.payment_reciepts,
    PatientInvoices: state => state.patient_invoices.data,
    Debtors: state => state.deptors,
    BadDebtors: state => state.bad_detors,
    AccountBalance: state => state.account_balance.data,
    PatientInvoiceDetails: state => state.patient_invoice_details,
    PaymentReciept: state => state.paymentreciet
};
export const mutations = {

    SET_PAYMENT_MODES: (state, newValue) => state.payment_modes = newValue,
    SET_CURRENCY: (state, newValue) => state.currencies = newValue,
    SET_PATIENT_PAYMENTS: (state, newValue) => state.patient_payments = newValue,

    SET_PAYMENTS_RECIEPT(state, newValue) {
        state.payment_reciepts = newValue.data
    },
    SET_PATIENT_INVOICES(state, newValue) {
        state.patient_invoices = newValue
    },
    SET_BAD_DEBTORS(state, newValue) {
        state.bad_detors = newValue
    },
    SET_DEBTORS(state, newValue) {
        state.deptors = newValue
    },
    SET_ACCOUNT_BALANCE(state, newValue) {
        state.account_balance = newValue
    },
    ADD_DISCOUNT_STATUS(state, newValue) {
        state.discount_status = newValue
    },
    SET_CLEAR_STATUS(state, newValue) {
        state.clear_status = newValue
    },
    SET_PRINT_RECIEPT(state, newValue) {
        state.print_reciept = newValue
    },
    INVOICE_GENERATE_STATUS(state, newValue) {
        state.invoice_generate_status = newValue
    },
    INVOICE_GET_STATUS(state, newValue) {
        state.personalInvoiceStatus = newValue
    },
    PAYMENT_RECEIPT_EMPTY(state) {
        state.paymentreciet = {}

    },
    PAYMENT_RECIEPT_STATUS(state, newValue) {
        state.payment_reciept_status = newValue
    },
    PAYMENT_MODE_STATUS(state, newValue) {
        state.pay_mode_status = newValue
    },

    SET_PATIENT_INVOICE(state, newValue) {
        state.patient_invoice_details = newValue
    },
    SET_PAYMENTRECIEPT(state, newValue) {
        state.paymentreciet = newValue
    },
    REMOVE_VISIT_OBJECT(state, index) {
        state.patient_payments.data.splice(index, 1);
    },
    REMOVE_DEBTOR_OBJECT(state, index) {
        state.deptors.splice(index, 1);
    },
    SET_RECIEPT_TEMPLATE(state) {
        state.paymentreciet = { "clinic_name": "", "clinic_address": "", "clinic_contact": "", "clinic_email": "", "clinic_logo": "", "clinic_stamp": "", "country": null, "birth_date": null, "printuser": "", "patient_name": "", "patient_code": "", "gender": null, "patient_contact": "", "age": null, "printDate": "", "date": "", "temperature": null, "pressure": null, "weight": null, "user": "", "serviceName": "", "serviceType": null, "clinicNotes": [], "all_tests": [], "notesVersion": null, "all_drugs": [], "all_procedures": [] }
    },
    SET_INVOICE_TEPLATE(state) {
        state.patient_invoice_details = {
            "payer": "",
            "due_date": "",
            "address": "",
            "code": "",
            "records": [],
            "clinicLogo": "",
            "stamp": "",
            "clinicName": "",
            "clinicAddress": "",
            "clinicPhone": "",
            "clinicEmail": "",
            "total": "",
            "paid_sofar": "",
            "discount": "",
            "previous": "",
            "balance": "",
            "printuser": ""
        }
    }
};
export const actions = {
    fetchPatientPayments({ commit }) {
        axios.get('payments').then(pp_res => {
            commit('SET_PATIENT_PAYMENTS', pp_res.data)
        })
    },
    fetchPaymentsReceipt({ commit }) {
        axios.get('all_reciepts').then(pr_res => {
            commit('SET_PAYMENTS_RECIEPT', pr_res.data)
        })
    },

    fetchPatientInvoices({ commit }) {
        axios.get('invoices').then(pi_res => {
            commit('SET_PATIENT_INVOICES', pi_res.data)
        })
    },
    fetchDebtors({ commit, dispatch }) {
        axios.get('debtors').then(pi_res => {
            commit('SET_DEBTORS', pi_res.data)
        }).catch(() => {
            let message = { 'msg': "Error fetching debtors" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchBadDebtors({ commit, dispatch }) {
        axios.get('bad_debtors').then(pi_res => {
            commit('SET_BAD_DEBTORS', pi_res.data)
        }).catch(() => {
            let message = { 'msg': "Error fetching bad debtors" }
            dispatch('notification/error', message, { root: true })
        })
    },
    closeDebtor({ dispatch }, payload) {
        axios.post('close_debtor', payload).then(() => {
            dispatch('fetchDebtors')
            let message = { 'msg': "Debtor closed successfully" }
                // DISPATCH MESSAGE MODUL
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': "Error closing debtor" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editDebtor({ dispatch }, payload) {
        axios.post('edit_debtor', payload).then(() => {
            dispatch('fetchDebtors')
            let message = { 'msg': "Debtor updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': "Error updating debtor" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchAccountBalance({ commit, dispatch }) {
        axios.get('accounts').then(ab_res => {
            commit('SET_ACCOUNT_BALANCE', ab_res.data)
        }).catch(() => {
            let message = { 'msg': "Error fetching account balance" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchCurrency({ commit }) {
        axios.get('currency').then(ab_res => {
            commit('SET_CURRENCY', ab_res.data)
        })
    },

    clearBalance({ commit, dispatch }, payload) {
        commit('SET_CLEAR_STATUS', true)
        commit('SET_PRINT_RECIEPT', false)
        axios.post('make_payment', payload).then(() => {
            commit('SET_CLEAR_STATUS', false)
            commit('SET_PRINT_RECIEPT', true)
            dispatch('fetchPatientPayments')
            dispatch('fetchPatientInvoices')
            dispatch('fetchDebtors')
            let message = { 'msg': "Payments made successfully" }
                // DISPATCH MESSAGE MODUL
            dispatch('notification/success', message, { root: true })

        }).catch(() => {
            commit('SET_CLEAR_STATUS', false)
            let message = { 'msg': "Error making payments" }
            dispatch('notification/error', message, { root: true })
        })
    },
    generateInvoice({ commit, dispatch }, payload) {
        dispatch('fetchPatientPayments')
        dispatch('fetchDebtors')
        commit('INVOICE_GENERATE_STATUS', true)
        axios.post('invoices', payload).then(() => {
            commit('INVOICE_GENERATE_STATUS', false)
            dispatch('fetchPatientPayments')
            dispatch('fetchDebtors')
            let message = { 'msg': "Invoice generated successfully" }
                // DISPACH MESSAGE MODUL
            dispatch('notification/success', message, { root: true })

        }).catch(() => {
            commit('INVOICE_GENERATE_STATUS', false)
            let message = { 'msg': "Error generating Invoice" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchPatientInvoice({ commit }, invoice_id) {
        commit('SET_INVOICE_TEPLATE')
        commit('INVOICE_GET_STATUS', true)
        axios.get(`invoices/${invoice_id}`).then((ires) => {
            commit('INVOICE_GET_STATUS', false)
            commit('SET_PATIENT_INVOICE', ires.data)
        })
    },
    fetchPaymentReciept({ commit }, pay_id) {
        commit('PAYMENT_RECIEPT_STATUS', true)
        commit('SET_RECIEPT_TEMPLATE')
        axios.get(`pay_reciept/${pay_id}`).then((pres) => {
            commit('SET_PAYMENTRECIEPT', pres.data)
            commit('PAYMENT_RECIEPT_STATUS', false)

        })
    },
    addDiscount({ commit, dispatch }, discount) {
        commit('ADD_DISCOUNT_STATUS', true)
        axios.put(`discount_visit/${discount.pay_id}`, discount).then((disc_esp) => {
            commit('SET_PATIENT_PAYMENTS', disc_esp.data)
            commit('ADD_DISCOUNT_STATUS', false)
            let message = { 'msg': "Discount added successfully" }
                // DISPACH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            commit('ADD_DISCOUNT_STATUS', false)
            let message = { 'msg': "Error adding discount" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // PAYMENT MODES
    fetchPaymentModes({ commit, dispatch }) {
        axios.get('paymentmodes').then(pm_res => {
            commit('SET_PAYMENT_MODES', pm_res.data)
        }).catch(() => {
            let message = { 'msg': "Error fetching payment modes" }
            dispatch('notification/error', message, { root: true })
        })
    },

    addPaymentMode({ commit, dispatch }, payload) {
        commit('PAYMENT_MODE_STATUS', true)
        axios.post('paymentmodes', payload).then(() => {
            commit('PAYMENT_MODE_STATUS', false)
            dispatch('fetchPaymentModes')
            let message = { 'msg': "Payment mode added successfully" }
                // DISPACH MESSAGE MODUL
            dispatch('notification/success', message, { root: true })

        }).catch(() => {
            commit('PAYMENT_MODE_STATUS', false)
            let message = { 'msg': "Error adding Payment mode" }
            dispatch('notification/error', message, { root: true })
        })
    },
    editPaymentMode({ commit, dispatch }, payload) {
        commit('PAYMENT_MODE_STATUS', true)
        axios.put(`paymentmodes/${payload.id}`, payload).then(() => {
            commit('PAYMENT_MODE_STATUS', false)
            dispatch('fetchPaymentModes')
            let message = { 'msg': "Payment mode edited successfully" }
            dispatch('notification/success', message, { root: true })

        }).catch(() => {
            commit('PAYMENT_MODE_STATUS', false)
            let message = { 'msg': "Error editing Payment mode" }
            dispatch('notification/error', message, { root: true })
        })
    },
    transferMoney({ commit, dispatch }, payload) {
        commit('PAYMENT_MODE_STATUS', true)
        axios.post('transfer_mode_money', payload).then(() => {
            commit('PAYMENT_MODE_STATUS', false)
            dispatch('fetchAccountBalance')
            let message = { 'msg': "Money transfered successfully" }
            dispatch('notification/success', message, { root: true })

        }).catch(() => {
            commit('PAYMENT_MODE_STATUS', false)
            let message = { 'msg': "Error transfering money" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deletePaymode({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('PAYMENT_MODE_STATUS', true);
        axios.delete(`paymentmodes/${payload.id}`).then((pm_res) => {
            commit('SET_PAYMENT_MODES', pm_res.data)
            let message = { 'msg': "Payment mode deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('PAYMENT_MODE_STATUS', false);
        }).catch(() => {
            commit('PAYMENT_MODE_STATUS', false)
            let message = { 'msg': "Error deleting Payment mode" }
            dispatch('notification/error', message, { root: true })
        })
    },
}